module.exports = __webpack_public_path__ + "static/img/ico-1.cafe5621.png";